import PhoneIcon from '@src/assets/icons/ic_phone_n.svg';
import React from 'react';
import './callbox-banner.scss';

type TCallBoxBanner = {
  text?: string;
  phone?: number;
  isOpen?: boolean;
};

export default function CallBoxBanner({ text, phone, isOpen }: TCallBoxBanner) {
  return (
    <div className={`callbox-banner ${isOpen ? 'callbox-banner--open' : ''}`}>
      <div className="callbox-banner__text">{text}</div>
      <a href={`tel:${phone}`}>
        <div className="callbox-banner__phone">
          <PhoneIcon />
          <span>{phone}</span>
        </div>
      </a>
    </div>
  );
}
